<template>
    <section>
        <div v-show="dancers.length" class="video-box df jcsb">
            <router-link v-for="v in dancers" :key="v.id" :to="`/dancers/${v.id}`" class="video-link">
                <div class="video-thumb" :style="`background-image: url(${v.thumb})`">
                    <div class="video-meta">
                        <div class="video-meta-play">
                            <i class="icon-hot"></i>{{$view(v.views)}}
                        </div>
                        <i class="icon-like"></i>{{$view(v.fans)}}
                    </div>
                </div>
                <div class="video-title">{{v.name}}</div>
            </router-link>
        </div>
        <div v-show="isLoading" class="loading-box"><div class="loading"></div></div>
        <div v-show="!isLoading && !dancers.length" class="empty">暂时没有舞者(～￣▽￣)～</div>
    </section>
</template>

<script>
    export default {
        props: {
            studio: String,
            avatar: String,
        },
        data: () => ({
            dancers: [],
            isLoading: true,
        }),
        async beforeMount() {
            this.dancers = await this.api.get(`studios/${this.$route.params.id}/dancers`).catch(this.err);
            this.isLoading = false;
            this.$share(`${this.studio}的舞者`, this.avatar);
        },
    }
</script>

<style scoped>
    @import '../../../static/css/home/video-list.css';

    .video-thumb {
        height: 45.07vw;
    }

    .video-title {
        height: 4.8vw;
    }
</style>


// WEBPACK FOOTER //
// src/components/studio/Dancer.vue